const fixFullscreen = e => e.target.scrollIntoView && e.target.scrollIntoView();

export default () => {
  ['', 'webkit', 'moz', 'ms'].forEach(prefix => {
    document.addEventListener(`${prefix}fullscreenchange`, fixFullscreen);
  });
};



// WEBPACK FOOTER //
// ./src/utils/fixVideoFullscreenScrolling.js